import AirportLoungeCard from './src';

export default AirportLoungeCard;
